var referrer =  window.location.href;
var href = window.location.href;
var query = href.indexOf("?view=discount-only");

if (query !== -1) {
  
  var ele = document.querySelectorAll('.variant-picker__option-values a');
  var rec_ele = document.querySelectorAll('.product-card__aside .product-card__swatch-list a');

  ele.forEach(function(input) {
   if (input.hasAttribute("data-sale")) {
     input.style.display="block";
     let get_href = input.getAttribute('href');
      get_href += "?view=discount-only";
      input.setAttribute('href',get_href);
   }
  else{
    input.style.display="none";
   }
  });
  
setTimeout(function(){
    var all_ele = document.querySelectorAll('product-card a');
    all_ele.forEach(function(anchorinput) {
    var get_refval = anchorinput.getAttribute('href');
    // get_refval += "?view=discount-only";
    anchorinput.setAttribute('href',get_refval);
  });
  var rec_ele = document.querySelectorAll('.product-card__aside .product-card__swatch-list a');
      rec_ele.forEach(function(inputs) {
      inputs.style.display="none";
      if (inputs.hasAttribute("data-sale")) {
        inputs.style.display="block";
        let get_hrefs = inputs.getAttribute('href');
        //get_hrefs += "?view=discount-only";
        inputs.setAttribute('href',get_hrefs);
        let get_rechref = inputs.parentNode.parentNode.parentNode;
      }
      else{
        inputs.style.display="none";
      }
      });
},1800)

}

document.addEventListener('DOMContentLoaded', function () {
  
  const checkAccordianHomepage = setInterval(() => {
    if(document.querySelector(".section-stack summary") != null) {
      if (window.location.pathname === '/') {
        setTimeout(function(){
          document.querySelectorAll(".section-stack summary").forEach(el => {
            el.click();
            el.style.height = "0px";
          })
          
        }, 1000);
      }
      clearInterval(checkAccordianHomepage);
    } 
  }, 100); 
  
}, false);

customElements.define('grid-custom-swatch',class gridCustomSwatch extends HTMLElement{
  constructor(){
    super();
    let productCard = this.closest('product-card');
    let isSale = productCard.dataset.isSale || window.location.href.includes("?view=discount-only").toString();
    this.querySelectorAll('.color-swatch-btn').forEach(button => {
      if(isSale == "true" && button.dataset.sale == "false"){
        button.remove();
       return; 
      }
      const gridCustomSwatch = document.querySelector('grid-custom-swatch');
      const buttons = this.closest('product-card').querySelectorAll('grid-custom-swatch button');      
      if (buttons.length > 1) {
          button.onclick = () => {
          fetch(`${button.dataset.url}?section_id=ajax-product-grid`)
          .then(data => data.text())
          .then(content => {
            const parser = new DOMParser();
            const html = parser.parseFromString(content, 'text/html');
            let newProductCard = html.body.querySelector('product-card');
            const currenQuickDrawerID = newProductCard.querySelector('quick-buy-drawer').getAttribute('id');
            const buttonAriaControls = newProductCard.querySelector('.quick_add_desk button');
            const buttonAriaControlsMobile = newProductCard.querySelector('button.product-card__mobile-quick-buy-button')

            if(isSale == "true"){
              newProductCard.querySelector('quick-buy-drawer').setAttribute('data-is-sale',true);
              
              newProductCard.setAttribute("data-is-sale",true);
              newProductCard.querySelectorAll('.color-swatch-btn[data-sale="false"]').forEach(btn => {
                btn.remove();
              });
              
              newProductCard.querySelectorAll('a[href*="/products/"]').forEach(ele => {
                ele.href = ele.href+"?view=discount-only";
              });
              
              
              // productCard.querySelector('quick-buy-drawer').setAttribute('data-is-sale',true);
            }
            
            // Generate a random number between 0 and 2
            const randomNumber = Math.floor(Math.random() * 3);
            // Generate a random 3-digit number
            const randomThreeDigitNumber = Math.floor(Math.random() * 900) + 100;
            // append the random number to the current quick drawer id
            let newID = currenQuickDrawerID +'-'+ randomThreeDigitNumber
            // set the new id to the quick drawer
            newProductCard.querySelector('quick-buy-drawer').setAttribute('id',newID);
            // set the new id to the button aria-controls
            buttonAriaControls.setAttribute('aria-controls',newID); 
            buttonAriaControlsMobile.setAttribute('aria-controls',newID);

            productCard.replaceWith(newProductCard);
          })
        }
        } 

    });
  }
});




  setTimeout(function() {
    const checkoutMethodElements = document.querySelectorAll('.checkoutMethod');
    const shippingChargeElement = document.querySelector('.shipping_chagre .shipping_amount');
    const storePickupElement = document.querySelector('.storepickup');
    const locakPickupElement = document.querySelector('.locakpickup');
    const shippingAmountElement = document.querySelector('.shipping_amount');
    const subtotalElement = document.querySelector('.subtotal_amount');
   
    
    
    if (checkoutMethodElements.length > 0) {
      const shippingCurrentValue = shippingChargeElement.innerHTML;
      const subtotal = subtotalElement.innerHTML;
      checkoutMethodElements.forEach(item => {
        item.addEventListener('click', function() {
          const optionValue = item.querySelector('.checkoutMethodName').innerHTML;
          const productType = shippingAmountElement.getAttribute('data-product-type') || '';
          
          if (optionValue.includes('Pickup')) {
            shippingChargeElement.innerHTML = 'Free';
            storePickupElement.classList.remove('hide');
            locakPickupElement.classList.add('hide');
          } else {
            shippingChargeElement.innerHTML = shippingCurrentValue;
            storePickupElement.classList.add('hide');
            locakPickupElement.classList.remove('hide');
            console.log(shippingCurrentValue);
            
            if (shippingCurrentValue.trim() == 'Free' || productType.trim() == 'gift_card') {
              shippingAmountElement.textContent = 'Free';
            } else {
              shippingAmountElement.textContent = '$40.00';
            }
          }
        });
      });
    }
  }, 2000);
